import Vue from "vue";
import Vuex from "vuex";
import {
  OPERATIONS_URL,
  PAGE_SIZE,
  CUSTOMERS_URL,
} from "@/constants/ServicesConstants";
import axios from "axios";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    isLoading: false,
    snackbar: {
      show: false,
      color: "info",
      message: "",
    },
  },
  getters: {},
  actions: {},
  modules: {
    operation: {
      namespaced: true,
      state: () => ({
        loadingOperations: false,
        loadingOperation: false,
        paidInstallment: {},
        operation: {},
        operations: [],
        operationsPagination: {
          total: 0,
          pageNumber: 1,
          pageSize: PAGE_SIZE,
        },
        searchParameters: {
          pageNumber: 1,
          pageSize: PAGE_SIZE,
          name: null,
          identificationNumber: null,
          operationNumber: null,
        },
        operationsStatus: null,
        operationIndex: 0,
        drawerFilter: false,
        dialogCreateOperation: false,
        dialogRegistrationPayment: false,
        dialogRegistrationExtraPayment: false,
        dialogActivateOperation: false,
        dialogApprovePayment: false,
        dialogRejectPayment: false,
        dialogNewness: false,
        dialogActivateOperationCustomer: false,
        dialogEditOperation: false,
        dialogCancelOperation: false,
        dialogReactivateOperation: false,
      }),
      actions: {
        _setLoadingOperations({ commit }, loading) {
          commit("setLoadingOperations", loading);
        },
        _setLoadingOperation({ commit }, loading) {
          commit("setLoadingOperation", loading);
        },
        async _getOperations({ state, commit }) {
          const response = await axios.get(`${OPERATIONS_URL}`, {
            params: state.searchParameters,
          });
          const { data, pageNumber, pageSize, total } = response.data;
          const operations = data;
          commit("setOperations", operations);
          commit("setOperationsPagination", { pageNumber, pageSize, total });
          return operations.length > 0 ? operations[0].id : null;
        },
        async _getOperation({ state, commit }, options = {}) {
          const { id, operationIndex } = options;
          const operationResponse = await axios.get(`${OPERATIONS_URL}/${id}`);
          const operation = operationResponse?.data || {};
          operation.customers = (operation.customers || []).map((customer) => {
            return { ...customer, showExtraInfo: false };
          });

          const index =
            operationIndex ??
            state.operations.findIndex((op) => String(op.id) === String(id));

          commit("setOperation", operation);
          commit("setOperationIndex", index >= 0 ? index : 0);
        },
      },
      mutations: {
        setLoadingOperations(state, payload) {
          state.loadingOperations = payload;
        },
        setLoadingOperation(state, payload) {
          state.loadingOperation = payload;
        },
        setLoadingCustomer(state, payload) {
          state.loadingCustomer = payload;
        },
        setOperation(state, payload) {
          state.operation = payload;
        },
        setCustomer(state, payload) {
          state.customer = payload;
        },
        setPaidInstallment(state, payload) {
          state.paidInstallment = payload;
        },
        setOperationIndex(state, payload) {
          state.operationIndex = payload;
        },
        setOperations(state, payload) {
          state.operations = payload;
        },
        setOperationsPagination(state, payload) {
          state.operationsPagination = payload;
        },
        setOperationsSearchParameters(state, payload) {
          state.searchParameters = { ...state.searchParameters, ...payload };
        },
        setOperationsStatus(state, payload) {
          state.operationsStatus = payload;
        },
        setOperationDrawerFilter(state, payload) {
          state.drawerFilter = payload;
        },
        clearOperationsSearchParameters(state) {
          state.searchParameters = {
            pageNumber: 1,
            pageSize: PAGE_SIZE,
          };
        },
        clearOperationsSearchSpecificParameters(state, param) {
          state.searchParameters[param] = null;
        },
      },
    },
    customer: {
      namespaced: true,
      state: () => ({
        customer: null,
      }),
      mutations: {
        setCustomer(state, customer) {
          state.customer = customer;
        },
      },
      actions: {
        async _getCustomer({ commit }, options = {}) {
          const { id } = options;
          const customerResponse = await axios.get(`${CUSTOMERS_URL}/${id}`);
          const customer = customerResponse?.data || {};
          commit("setCustomer", customer);
        },
      },
    },
    country: {
      namespaced: true,
      state: () => ({
        countries: [],
      }),
      mutations: {
        setCountries(state, countries) {
          state.countries = countries;
        },
      },
      actions: {
        async _getCountries({ commit }) {
          commit("setCountries", []);
        },
      },
    },
  },
  mutations: {
    setDrawerFilter(state, value) {
      state.operation.drawerFilter = value;
    },
    setDialogRegistrationPayment(state) {
      state.operation.dialogRegistrationPayment =
        !state.operation.dialogRegistrationPayment;
    },
    setDialogRegistrationExtraPayment(state) {
      state.operation.dialogRegistrationExtraPayment =
        !state.operation.dialogRegistrationExtraPayment;
    },
    setDialogApprovePayment(state) {
      state.operation.dialogApprovePayment =
        !state.operation.dialogApprovePayment;
    },
    setDialogRejectPayment(state) {
      state.operation.dialogRejectPayment =
        !state.operation.dialogRejectPayment;
    },
    setDialogActivateOperation(state) {
      state.operation.dialogActivateOperation =
        !state.operation.dialogActivateOperation;
    },
    setDialogCreateOperation(state) {
      state.operation.dialogCreateOperation =
        !state.operation.dialogCreateOperation;
    },
    setDialogNewness(state) {
      state.operation.dialogNewness = !state.operation.dialogNewness;
    },
    closeSnackbar(state) {
      state.snackbar.show = false;
    },
    setDialogActivateOperationCustomer(state) {
      state.operation.dialogActivateOperationCustomer =
        !state.operation.dialogActivateOperationCustomer;
    },
    setDialogEditOperation(state) {
      state.operation.dialogEditOperation =
        !state.operation.dialogEditOperation;
    },
    setDialogCancelOperation(state) {
      state.operation.dialogCancelOperation =
        !state.operation.dialogCancelOperation;
    },
    setDialogReactivateOperation(state) {
      state.operation.dialogReactivateOperation =
        !state.operation.dialogReactivateOperation;
    },
  },
});
export default store;
